import React from 'react';
import { Trans } from 'react-i18next';
import { Box, Tooltip, InfoIcon } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { PaymentInfoProps } from '@epi-models/forms/PaymentMethod';
import { PaymentMethods } from '@epi-constants/paymentMethods';

export function PaymentInfo({ title }: PaymentInfoProps) {
  const theme = useTheme();

  return (
    <Box display="flex" mb={0.5}>
      <Tooltip
        arrow
        placement="top"
        id={`${PaymentMethods.CreditCard}-tooltip`}
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: '500px'
            }
          }
        }}
        title={<Trans i18nKey={title} />}
      >
        <Box id={`${PaymentMethods.CreditCard}-info-icon`}>
          <InfoIcon color={theme.primaryFrontColor} />
        </Box>
      </Tooltip>
    </Box>
  );
}
